import isEqual from 'lodash/isEqual';

import { mString } from 'lib/helpers/utility';

import { CPT_CODE_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

import Actions from '../components/Actions';

export const ndcCodesOptions = (ndcCodes) => {
  return ndcCodes?.map((item) => ({
    value: item?.package_ndc,
    label: item?.package_ndc
  }));
};

export const defaultFilters = () => ({
  search: {
    type: 'search',
    fields: [
      { field: 'id', label: 'ID' },
      { field: 'name', label: 'Name' },
      { field: 'procedure_code', label: 'Code' }
    ]
  },
  procedure_code: {
    ...CPT_CODE_OPTIONS,
    title: 'Procedure code',
    allowed_operators: ['is', 'is any of', 'is not']
  },
  name: {
    title: 'Name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  description: {
    title: 'Description',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'file-text-mono'
  },
  time_length: {
    title: 'Time length',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'timer-mono'
  },
  self_pay_amount: {
    type: 'range',
    title: 'Self pay amount',
    icon: 'dollar-circle-mono'
  },
  standard_charge: {
    type: 'range',
    title: 'Standard charge',
    icon: 'money-receive-mono'
  },
  medicare_allowable_amount: {
    type: 'range',
    title: 'Medicare allowable amount',
    icon: 'dollar-square-mono'
  }
});

export const defaultColumns = () => [
  {
    field: 'procedure_code',
    headerName: 'Procedure code',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'name',
    headerName: 'Name',
    tooltipField: 'name',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'description',
    cellClass: 'no-border',
    headerName: 'Description',
    tooltipField: 'description',
    flex: 1
  },
  {
    field: 'time_length',
    headerName: 'Time length',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'total_cost_cents',
    headerName: 'Self pay amount',
    cellClass: 'no-border',
    flex: 1,
    valueFormatter: ({ value }) => mString(value)
  },
  {
    field: 'standard_charge',
    headerName: 'Standard charge',
    cellClass: 'no-border',
    flex: 1,
    valueFormatter: ({ value }) => mString(value)
  },
  {
    field: 'cpt.par_amount',
    headerName: 'Medicare allowable amount',
    cellClass: 'no-border',
    flex: 1,
    valueFormatter: ({ value }) => mString(value)
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

/**
 * @param {Object} updatedService - The updated service object.
 * @param {Object} service - The original service object.
 * @returns {Object} - An object containing the changes.
 */
export const getServiceChanges = (updatedService, service) => {
  const serviceChanges = {};
  for (const key in updatedService) {
    if (!isEqual(updatedService[key], service[key])) {
      serviceChanges[key] = updatedService[key];
    }
  }
  return serviceChanges;
};

/**
 * @param {Object} values - The current pay schedule values from formik.
 * @param {Object} initialValues - The initial pay schedule values (e.g., service.payerConnection).
 * @returns {Array} - An array of objects that contain the changes in the pay schedule.
 */
export const getPayScheduleChanges = (values, initialValues) => {
  const payScheduleChanges = [];
  for (const key in values) {
    if (
      values[key].allowable_amount_cents !== initialValues[key].allowable_amount_cents ||
      values[key].adjustment_amount_cents !== initialValues[key].adjustment_amount_cents
    ) {
      payScheduleChanges.push(values[key]);
    }
  }
  return payScheduleChanges;
};
